// extracted by mini-css-extract-plugin
export default {"licenseInfo":"ActivateLicenseDialog_licenseInfo__MQI7E","contentInfo":"ActivateLicenseDialog_contentInfo__BR2rV"};